import { useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { makeUploadSchema } from './make.schema';
import { MakeUploadFormData } from './projectMake.d';

// eslint-disable-next-line import/prefer-default-export
export const useMakeUploadForm = () => {
  return useForm<MakeUploadFormData>({
    resolver: zodResolver(makeUploadSchema),
    defaultValues: {
      images: [],
      selectedPrinter: '',
      didCutProject: undefined,
      ratings: {
        cutExpectation: 0,
        cutQuality: 0,
        correctFileInfo: 0,
        coolFactor: 0,
      },
      caption: '',
    },
    mode: 'onChange',
  });
};
